<template>
    <div>
        <!-- Botón Menú (Arriba Izquierda) -->
        <button @click="toggleDrawer" class="btn-control btn-menu">
            <i class="fas fa-bars"></i>
        </button>

        <!-- Controles Mapa (Abajo Derecha) -->
        <div class="map-controls">
            <SpatialFilterControl />
            <!--Tooltips agregados segun observacion SENAPRED 06/2026 ("No tiene tooltip")-->
            <button @click="zoomIn" class="btn-control" title="Acercar Imagen">
                <!--iconos cambiado segun observaciones SENAPRED 06/2026 ("No tiene tooltip. El símbolo no está centrado verticalmente")-->
                <i class="fas fa-plus"></i>
            </button> 
            <button @click="zoomOut" class="btn-control" title="Alejar Imagen">
                <!--iconos cambiado segun observaciones SENAPRED 06/2026 ("No tiene tooltip. El símbolo no está centrado verticalmente")-->
                <i class="fas fa-minus"></i>
            </button>
            <button @click="resetView" class="btn-control" title="Vista Inicial">
                <i class="fas fa-home"></i>
            </button>
            <button @click="geolocate" class="btn-control" title="Mi Ubicación">
                <i class="fas fa-crosshairs"></i>
            </button>
            <button @click="toggleFullscreen" class="btn-control" title="Full Extent">
                <i class="fas fa-expand"></i>
            </button>
        </div>
    </div>
</template>

<script>
import { mapCustomControlsService } from "@/services/map/mapCustomControlsService";
import SpatialFilterControl from "@/components/mapControls/SpatialFilterControl.vue";

export default {
    name: "MapControlsCustom",
    components: { SpatialFilterControl },

    methods: {
        toggleDrawer() {
            this.$store.dispatch('setMapControlSelection', {
                control: 'navDrawer',
                active: true
            });
        },
        zoomIn() {
            mapCustomControlsService.zoomIn();
        },
        zoomOut() {
            mapCustomControlsService.zoomOut();
        },
        resetView() {
            mapCustomControlsService.resetView();
        },
        geolocate() {
            mapCustomControlsService.locate();
        },
        toggleFullscreen() {
            mapCustomControlsService.toggleFullscreen();
        }
    }
};
</script>

<style scoped>
.map-controls {
    position: absolute;
    right: 20px;
    bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    z-index: 2000;
}

.btn-menu {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 2000;
}

.btn-control {
    width: 42px;
    height: 42px;
    background: #0077c8;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 22px;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-control:hover {
    background: #005fa3;
}
</style>
